import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import HTMLParser from 'html-react-parser';
import { Parking, Garden, Size, CouncilTax } from "../../../icons/icons";
import "./Amenities.scss";

const Amenities = (props) => {
    return (
        <div className="property-amenities-wrap">
            <Container>
                <Row>
                    <Col lg={6}  xxl={7} className="owners-love-section">
                        {props?.extra?.extrasField?.pNoticed && (
                            <div className="owners-love">
                                <h5 className="sec-title">We’ve Noticed</h5>
                                <ul className="comment-list">
                                    {props?.extra?.extrasField?.pNoticed
                                        .split(/\r?\n|\r/) // ✅ split by line breaks
                                        .filter((item) => item.trim() !== '')
                                        .map((item, index) => (
                                        <li key={index}>{item.trim()}</li>
                                        ))}
                                </ul>
                            </div>
                        )}
                    </Col>
                    {props.isFeatureShow && (
                    <Col lg={6}  xxl={7} className="key-feature">
                        <h5 className="sec-title">Key Features</h5>
                        <div className="list-wrap d-md-flex">
                            {props.accommodation ?
                                <ul className="desc-list">
                                    {props.accommodation.map(summary => (
                                        <li>{HTMLParser(summary.replace(/^•\s*/, ""))}</li>
                                    ))}
                                </ul>
                                : ''
                            }
                        </div>
                    </Col>
                    )}
                    {/* <Col lg={6} className="amenities">
                        <h5 className="sec-title">Amenities</h5>
                        <ul className="amenities-list">
                            {props?.parking &&
                                <li className="parking">
                                    <Parking />
                                    <div className="list-data">
                                        <h6>Parking</h6>
                                        <p>{props?.parking}</p>
                                    </div>
                                </li>
                            }
                            {props?.situation &&
                                <li className="situation">
                                    <Garden />
                                    <div className="list-data">
                                        <h6>Garden</h6>
                                        {props.situation.includes("garden") && <p>Yes</p>}
                                    </div>
                                </li>
                            }
                            {props?.size &&
                                <li className="size">
                                    <Size />
                                    <div className="list-data">
                                        <h6>Size</h6>
                                        <p>{props?.size}</p>
                                    </div>
                                </li>
                            }
                            {props.extra?.councilTax &&
                                <li className="size">
                                    <CouncilTax />
                                    <div className="list-data">
                                        <h6>Council tax</h6>
                                        <p>Band {props.extra?.councilTax}</p>
                                    </div>
                                </li>
                            }
                        </ul>
                    </Col> */}
                </Row>
            </Container>
        </div>
    );
};

export default Amenities;